import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './assets/styles/index.scss';
import Header from './components/Header';
import Footer from "./components/Footer";
import * as serviceWorker from './services/serviceWorker';
import Content from "./components/Content";

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <Header />
    <Content />
    <Footer />
  </StrictMode>
);

serviceWorker.unregister();